export default "__VITE_ASSET__Binr1rGC__"